import React, { Component } from 'react'
import ButtonAnimated from '../../../components/buttons/ButtonAnimated';
import { translate } from '../../../utils/useful';
import SwitchButton from '../../../components/useful/SwitchButton';
import Collapsible from 'react-collapsible';
import AnswerSheetForm from './AnswerSheetForm';
import Modal from '../../../components/Modal';

class AnswerSheet extends Component {

    state = {
        questions: [],
        answers: [],
        scoreData: [],
        scoreHeader: [],
        scores: [],
        disableInputs: false
    }

    componentDidMount() {
        console.log('questiooooons', this.props.data?.values)
        if (this.props.data && this.props.data?.values && this.props.data?.values?.questions) {
            // let scoreHeader=this.state.scoreHeader
            // this.props.data?.values?.questions.forEach(el => {
            //     scoreHeader.push(
            //         { key: `${el.key}1`, id: `${el.id}1`, type: 'NumberInput', information: { disabled: false, label: "{{lang}}Number", placeholder: "{{lang}}Score" } }
            //     )
            // });
            this.setState({ questions: this.props.data?.values?.questions, scoreHeader: this.props.data?.values.scoreHeader }, () => {
            })
        }
        console.log('this.props.collectionId', this.props)
        // this.props.changeBackbtn(true)
        // console.log('this.props.editForm', this.props.editForm)
        if (this.props.editForm) {
            // console.log('newInquiryasdqqqqqqqqqq')
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                title: '{{lang}}Edit Inquiry',
                // headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.changeStage('form')
            })
        }
        else {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                title: '{{lang}}New Inquery',
                // headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.changeStage('form')
            })
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.showSubmitModal}
                    title='{{lang}}Submit'
                    icon='/assets/icons/arrow-right-white.svg'
                    // icon='/assets/icons/plus-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>
        )
    }

    showSubmitModal = () => {
        this.submitModal.showModal()
    }

    nextStage = (stage) => {
        let form = this.form.getForm()
        console.log('forrrrrrm', form)
        if (form != 'undefined') {
            this.props.setData({ 'values.answers': form.answers }, () => {
                if (this.props.hasScore) {
                    if (Object.entries(form.scores).length > 0) {
                        this.props.setData({ 'values.scores': form.scores }, () => {
                            this.props.postRecord(() => {

                            })
                        })
                    }
                } else {
                    this.props.postRecord(() => {

                    })

                }
            })

            console.log('ffffffffff', this.props.data)
        }
    }
    editNextStage = (stage) => {
        let form = this.form.getForm()
        this.props.postEditRecord(() => {
            if (form != 'undefined') {
                this.props.setData({ 'values.answers': form.answers }, () => {
                    if (this.props.hasScore) {
                        if (Object.entries(form.scores).length > 0) {
                            this.props.setData({ 'values.scores': form.scores })
                        }
                    }
                })
            }
        })
        // let rawData = this.state.formContent
        // if (rawData) {

        //     let questions = []
        //     rawData[0].pageContent[0].sectionContent.map((prop) => {
        //         prop.rowContent.map((element) => {
        //             questions.push(element)
        //         })
        //     })

        //     this.props.setData({ 'values.questions': questions }, () => {
        //         this.props.postEditRecord(() => {
        //             this.submitModal.hideModal()
        //         })
        //     })
        // }
    }
    // nextStage = (stage) => {
    //     let form = this.form.getForm()
    //     console.log('forrrrrrrrrm1', form)
    //     return
    //     let rawData = this.state.formContent
    //     console.log(rawData)
    //     if (rawData && rawData[0]?.pageContent && rawData[0]?.pageContent[0]) {
    //         let questions = []
    //         rawData[0].pageContent[0].sectionContent.map((prop) => {
    //             prop.rowContent.map((element) => {
    //                 questions.push({ ...element })
    //             })
    //         })

    //         this.props.setData({ 'values.questions': questions }, () => {
    //             this.props.postRecord(() => {
    //                 this.submitModal.hideModal()
    //             })
    //         })
    //     }
    // }

    setData = (key, value) => {
        this.setState({ [key]: value }, () => {
            let second = 0
        })
    }

    changeValue = (key, value) => {
        // console.log('changeValue')
        this.setState({ [key]: value }, () => {
            // if (this.state.public) {
            //     this.setState({ publicPermissions: '*' })
            // }
        })
    }

    onChangeAnswerSheet = (id, isOn) => {
        this.props.setData({ 'values.hasAnswerSheet': isOn }, () => {
        })
    }

    onChangeScore = (id, isOn) => {
        console.log('ascsdvsdvsddssherrrrr11111111');
        this.props.setData({ 'values.hasScore': isOn }, () => {
        })
    }


    onSeeAnswer = (id, isOn) => {
        console.log('ascsdvsdvsddssherrrrr');
        this.props.setData({ 'values.seeAnswer': isOn }, () => {
            console.log('ascsdvsdvsddss', this.props.data);
        })
    }
    render() {

        let disableInputs = this.state.disableInputs

        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        let hub = this.props.initData?.hub
        variables.hub = hub
        variables.targetId = hub
        let searchTab = this.state.searchTab

        return (
            <div className='w-100 h-100'>
                <div className='pt-4 d-flex flex-column px-4 h-100 scroll-no-scrollbar' style={{}}>
                    <p className='font-size-16 weight-700 pb-3'>{translate('Answers and Scores of Questions')}</p>
                    <div className='flexcb pb-3 w-100'>
                        <p className='font-size-14 weight-500 pr-3'>{translate('Do you want to have answer sheet?')}</p>
                        <SwitchButton color={this.props.colors ? this.props.colors?.primaryColor : '#FFCC00'} id={'answersheet'} disabled={disableInputs} isOn={this.props.data.values.hasAnswerSheet} onChange={this.onChangeAnswerSheet} />
                    </div>
                    <div className='flexcb pb-3 w-100'>
                        <p className='font-size-14 weight-500 pr-3'>{translate('Do you want to add scores for questions?')}</p>
                        <SwitchButton color={this.props.colors ? this.props.colors?.primaryColor : '#FFCC00'} id={'scoresheet'} disabled={disableInputs} isOn={this.props.data.values.hasScore} onChange={this.onChangeScore} />
                    </div>
                    <div className='flexcb pb-4 w-100'>
                        <p className='font-size-14 weight-500 pr-3'>{translate('Do you want participants to be able to see answer sheet?')}</p>
                        <SwitchButton color={this.props.colors ? this.props.colors?.primaryColor : '#FFCC00'} id={'seeanswer'} disabled={disableInputs} isOn={this.props.data.values.seeAnswer} onChange={this.onSeeAnswer} />
                    </div>
                    {/* {this.props.hasAnswerSheet&&(
                    <div className='row m-0 p-0'>
                        <div className={(this.props.hasScore ? 'pl-0 pr-3 pr-md-0 col-9 col-sm-8' : 'pl-0 pr-3 pr-md-0 col-12')}>
                            <p className='font-size-14 weight-600'>{translate('Answers')}</p>
                        </div>
                        {this.props.hasScore && (
                            <div className={(this.props.hasScore ? 'pr-0 pl-3 pl-md-0 col-3 col-sm-4' : 'pr-0 pl-3 pl-md-0 col-0')}>
                                <p className='font-size-14 weight-600'>{translate('Scores')}</p>
                            </div>
                        )}
                    </div>
                    )} */}
                    <Collapsible open={this.props.data.values.hasAnswerSheet}>
                        <div className='w-100 flexc pt-3'>
                            {/* <div className='row m-0 p-0 w-100'> */}
                            {/* <div className={(this.props.hasScore ? 'pl-0 pr-3 pr-md-0 col-9 col-sm-8' : 'pl-0 pr-3 pr-md-0 col-12')}> */}
                            <AnswerSheetForm ref={el => this.form = el} initData={this.props.data?.values?.answers} data={this.state.answers} scoreData={this.state.scoreData} scoreInitData={this.props.data?.values?.scores} headers={this.state.questions} questions={this.state.questions} inputClass={'modern-input'} nopadding={true} hasScore={this.props.data.values.hasScore} disableInputs={disableInputs} />
                            {/* </div> */}
                            {/* {this.props.hasScore && (
                                    <div className={(this.props.hasScore ? 'pr-0 pl-3 pl-md-0 col-3 col-sm-4' : 'pr-0 pl-3 pl-md-0 col-0')}>
                                        {console.log('this.state.scoreHeader', this.props.scoreHeader)}
                                        <AnswerSheetForm ref={el => this.form2 = el} initData={this.state.scores} data={this.state.scores} scoreData={this.state.scoreData} headers={this.state.scoreHeader} questions={this.state.questions} inputClass={'modern-input'} nopadding={true} hasScore={this.props.hasScore} />
                                    </div>
                                )} */}
                            {/* </div> */}
                        </div>
                    </Collapsible>
                </div>
                <Modal ref={el => this.submitModal = el} maxWidth={400}>
                    <div className="flexcc flex-column p-3 bg-white br-15" >
                        <p className="text-center text-semibig main-c3 text-semibold mt-2">{this.props.editForm ? translate("Edit Inquiry") : translate("Create Inquiry")}</p>
                        <p className="text-center font-size-13 main-c7 mt-2 px-2">{translate('Are you sure about the information? If all is ok, click confirm to create the inquiry')}</p>
                        <div className="flexcc w-100 mt-4 mb-2" style={{}}>

                            {/* <button className="modalCancelButton mrd-2 br-20" onClick={() => this.submitModal.hideModal()}>
                                <p className="font-size-14">{translate('Cancel')}</p>
                            </button> */}
                            <div className="mrd-1">
                                <ButtonAnimated
                                    // icon={'/assets/icons/check-white.svg'}
                                    bg={'rgba(120, 120, 120, 0.1)'}
                                    textColor={'rgb(120, 120, 120)'}
                                    title={'{{lang}}Cancel'}
                                    onClick={() => this.submitModal.hideModal()}
                                />
                            </div>
                            <div className="mld-1">
                                {this.props.editForm ?
                                    <ButtonAnimated
                                        icon={'/assets/icons/check-white.svg'}
                                        bg={this.props.colors?.background}
                                        textColor={this.props.colors?.textColor}
                                        title={'{{lang}}Edit'}
                                        onClick={() => this.editNextStage()}
                                    />
                                    :
                                    <ButtonAnimated
                                        icon={'/assets/icons/check-white.svg'}
                                        bg={this.props.colors?.background}
                                        textColor={this.props.colors?.textColor}
                                        title={'{{lang}}Create'}
                                        onClick={() => this.nextStage()}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default AnswerSheet;